import { gql } from 'apollo-angular';

export const userGridConfigurationMutation = gql`
  mutation UserGridConfiguration($configuration: UserGridConfigurationInput!) {
    userGridConfiguration (configuration: $configuration) {
      configuration
    }
  }
`;
